import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Dataset, UpdateDatasetRequest } from '../../model/dataset/dataset';
import { Point } from 'src/app/model/geometry/point';

@Injectable({
    providedIn: 'root'
})
export class DatasetService {

    constructor(private readonly http: HttpClient) {
    }

    getDataset(id: string): Observable<Dataset> {
        return this.http.get<Dataset>(`/datasets/${id}`);
    }

    getExternalDataset(datasetId: any): Observable<Dataset> {
        return this.http.get<Dataset>(`/tessadata/${datasetId}`);
    }

    getDatasets(datasetIDs: string[]): Observable<Dataset[]> {
        return this.http.get<Dataset[]>('/datasets', { params: { ids: datasetIDs } });
    }

    getThematicMapDatasets(): Observable<Dataset[]> {
        return this.http.get<Dataset[]>('/datasets/thematic-map');
    }

    updateDataset(request: UpdateDatasetRequest): Observable<Dataset> {
        return this.http.put<Dataset>('/datasets', request);
    }

 //   fetchTensorflight(request: any, datapointId: string): Observable<any> {
   //     return this.http.post<any>('/tensorflight/' + datapointId, request);
    //}

    fetchPreciselyData(request:any, datapointId: string): Observable<any> {
        return this.http.post<any>('/precisely/' + datapointId, request);
    }

    /**
     * Census block group boundary for a location, drawn on the map while the Precisely Crime
     * profile is selected.
     *
     * lat/lng are optional and enable the backend's point-in-polygon fallback for a GEOID the
     * configured boundary layer does not carry. A location with no boundary answers
     * `{ found: false }` rather than an error - block groups are US-only.
     */
    fetchBlockGroupGeometry(geoid: string, lat?: number, lng?: number, vintage?: string): Observable<any> {
        let params: { [key: string]: string } = {};
        if (lat !== undefined && lat !== null) {
            params['lat'] = String(lat);
        }
        if (lng !== undefined && lng !== null) {
            params['lon'] = String(lng);
        }
        if (vintage) {
            params['vintage'] = vintage;
        }
        return this.http.get<any>(`/precisely/block-group/${geoid}/geometry`, { params });
    }

    fetchPreciselyWildfirePolygon(request:any, datapointId: string): Observable<any> {
        return this.http.post<any>('/precisely/wildfire/' + datapointId, request);
    }

    fetchPreciselyWildfirePolygonByLocation(request:any): Observable<any> {
        return this.http.post<any>('/precisely/wildfire/by-location', request);
    }

}
